import "./CpraScript.css";
import React from "react";
import autobind from "autobind-decorator";

class CpraScript extends React.Component {
    @autobind
    handleCpraLinkClick() {
        window.privacy_choices();
    }

    render() {
        return (
            <React.Fragment>
                <button onClick={this.handleCpraLinkClick} className="cpra-button" id="cpra-button">
                    Your Privacy Choices&nbsp;
                    <img className="privacy-options-icon" src={require("/shared/assets/PrivacyOptions.png")} alt="Privacy Options" />
                </button>
                <script type="text/javascript" dangerouslySetInnerHTML={{
                    __html:
`
function privacy_choices() {
    window.evidon.notice.showOptions();
    }
`
                }}
                />
            </React.Fragment>
        );
    }
}

export default CpraScript;